/* eslint-disable react-refresh/only-export-components */
import type {ReactElement} from 'react';
import {useContext} from 'react';
import {ToggleSwitch, ToggleSwitchV2Size} from '@Components/toggle-switch-v2';
import {Text, TextSize} from '@Components/text';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {useComponentAttribute} from '@EmailMakerReact/lib/email-maker-component-style-library';
import type {EmailMakerControl, EmailMakerControlProps} from '../../right-panel-registry.types';
import {createDescriptorControl} from '../create-descriptor-control';
import type {ToggleSwitchDescriptor} from './toggle-switch-control.types';
import styles from './toggle-switch-control.module.scss';

interface ToggleSwitchControlInnerProps extends EmailMakerControlProps {
  descriptor: ToggleSwitchDescriptor;
}

function ToggleSwitchControlInner({component, descriptor}: ToggleSwitchControlInnerProps): ReactElement {
  const {editor} = useContext(emailMakerContext);
  const attributeValue = useComponentAttribute(component, descriptor.attribute);
  const isOn = descriptor.isOn(attributeValue);
  const label = window.i18next.t(descriptor.labelKey);

  function handleToggle(): void {
    if (!editor) {
      return;
    }
    descriptor.onToggle(editor, component, !isOn);
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.labelRow}>
        <Text val={label} size={TextSize.MD} className={styles.label} />
        <ToggleSwitch id={descriptor.attribute} isChecked={isOn} onChange={handleToggle} size={ToggleSwitchV2Size.SMALL} elementTitle={label} />
      </div>
    </div>
  );
}

export function makeToggleSwitchControl(descriptor: ToggleSwitchDescriptor): EmailMakerControl {
  return createDescriptorControl(ToggleSwitchControlInner, descriptor);
}
